import permissions from './permission-list'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/index.vue'),
    meta: {
      pageTitle: 'Pengaturan',
      resource: permissions.setting,
      action: 'read',
      navActiveLink: 'settings',
      breadcrumb: [
        {
          text: 'Daftar Pengaturan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/settings/create',
    name: 'settings-create',
    component: () => import('@/views/settings/create.vue'),
    meta: {
      pageTitle: 'Buat Pengaturan',
      resource: permissions.setting,
      action: 'manage',
      navActiveLink: 'settings',
      breadcrumb: [
        {
          text: 'Pengaturan',
          active: false,
          to: { path: '/settings' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/settings/:key/edit',
    name: 'settings-edit',
    component: () => import('@/views/settings/edit.vue'),
    meta: {
      pageTitle: 'Edit Pengaturan',
      resource: permissions.setting,
      action: 'manage',
      navActiveLink: 'settings',
      breadcrumb: [
        {
          text: 'Pengaturan',
          active: false,
          to: { path: '/settings' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
